import { IFechaFestiva } from "../../entities/catalogos/IFechaFestiva";
import { LOAD_DIAS_FESTIVOS_SUCCESS, DiasFestivosActionTypes } from "../types/diasFestivosActionTypes";


export default function diasFestivosReducer(state = [], action: DiasFestivosActionTypes): IFechaFestiva[] {
    switch (action.type) {
        case LOAD_DIAS_FESTIVOS_SUCCESS:
            return action.diasFestivos;
        default:
            return state;
    }
}

